export function isValidEmail(email: string) {
  // simple UI-level check for demo purposes
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function isValidDomain(domain: string) {
  const value = domain.trim().toLowerCase().replace(/^@+/, "");
  if (value.length === 0) return false;

  // Basic domain validation supporting subdomains
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(
    value,
  );
}

export function normalizeDomain(value: string) {
  return value.trim().toLowerCase().replace(/^@+/, "");
}

export function buildInviteLink(code: string) {
  return `${window.location.origin}/invite/${code}`;
}
